<template>
  <f7-page
    @page:beforein="beforein"
  >
    <navbar :text="`${$t('Configuration.name')} > ${$t('Page_subtitle_variety')}`" />
    <VarietyDatabase
      v-if="loaded"
      :groups-availables="groupsAvailables"
      :species-availables="speciesAvailables"
    />
  </f7-page>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import VarietyDatabase from '../../../components/configuration/varieties/varietyDatabase/index.vue';
import navbar from '../../../components/NavBar.vue';

export default {
  name: 'Varieties',
  components: {
    VarietyDatabase,
    navbar,
  },
  data() {
    return {
      loaded: false,
    };
  },
  computed: {
    ...mapState('Varieties', ['groupsAvailables', 'speciesAvailables']),
  },

  methods: {
    async beforein() {
      this.$f7.preloader.show();
      try {
        await this.getVarieties();
        await this.getGroupsAvailables();
        await this.getSpeciesAvailables();
      } catch (error) {
        this.$f7.dialog.alert(this.$t(`${error}`));
      } finally {
        this.loaded = true;
        this.$f7.preloader.hide();
      }
    },
    ...mapActions('Varieties', ['getVarieties', 'getGroupsAvailables', 'getSpeciesAvailables']),
  },

};
</script>
